import Loader from "@appComponents/Loader/Loader";
import SmallPriceChart from "@appComponents/SmallPriceChart/SmallPriceChart";
import SecondaryMarketService from "@services/SecondaryMarket.service";
import React, { useEffect } from "react";
import { useState } from "react";

type SPVPriceChartProps = {
  spvId: number;
  spvTradingAssetId: number;
};

export const SPVPriceChart = ({
  spvId,
  spvTradingAssetId,
}: SPVPriceChartProps) => {
  const [loading, setLoading] = useState(true);
  const [tradesList, setTradesList] = useState([]);

  useEffect(() => {
    SecondaryMarketService.getPublicTradesHistory(spvTradingAssetId).then(
      (resp) => {
        setLoading(false);
        setTradesList(resp.data);
      }
    );
  }, []);

  if (loading) {
    return <Loader small />;
  }

  return (
    <SmallPriceChart
      assetId={spvId}
      tradesList={tradesList || []}
      hidePercentage
      color="#81109c"
      width={100}
      height={27}
    />
  );
};
